import * as React from "react";
import { DentalInfo, getSmileSatisfactionI18n } from "../patient-portal/DentalInfo";
import LabelledDataForm from "../label/LabelledDataForm";

export default function DentalInformationItemsList({
  dentalInfo,
  fullDetails,
}: {
  dentalInfo: DentalInfo;
  fullDetails: Boolean;
}) {
  const data = [
    {
      label: i18n["Page.Portal.DentalInformation.SmileSatisfaction.Title"],
      value: i18n[getSmileSatisfactionI18n(dentalInfo.smileSatisfaction)],
    },
  ];
  if (dentalInfo.hasDentist) {
    data.push(
      {
        label: i18n["Form.Field.Title.PracticeName"],
        value: dentalInfo.practiceName,
      },
      {
        label: i18n["Form.Field.Title.DentistName"],
        value: dentalInfo.dentistName,
      },
      {
        label: i18n["Page.Portal.DentalInformation.LastDentalCleaning.Title"],
        value: dentalInfo.lastDentalCleaning,
      },
      {
        label: i18n["Page.Portal.DentalInformation.PendingTreatment.Title"],
        value: dentalInfo.pendingTreatment ? i18n["Global.Yes"] : i18n["Global.No"],
      },
      {
        label: i18n["Page.Portal.DentalInformation.PendingTreatmentDescription.Title"],
        value: dentalInfo.pendingTreatment && dentalInfo.pendingTreatmentDescription,
      }
    );
  }

  return (
    <>
      <LabelledDataForm data={data} />
      {!dentalInfo.hasDentist && (
        <div className={fullDetails ? "centered inline-form-editor line-grid" : " line-grid"}>
          <span className={fullDetails ? "no-information-message" : ""}>
            {fullDetails
              ? i18n["Page.Patient.FullDetails.DentalInformation.DontHaveDentist"]
              : i18n["Page.Portal.DentalInformation.DontHaveDentist"]}
          </span>
        </div>
      )}
    </>
  );
}
